export const AccountType = {
    None: 0,
    AthenaAccount: 1,
    AnsaradaAccount: 2
}